import { useUserInfoStore } from "@/stores/userInfo";
import styles from "./index.module.scss";
type Props = {
  approvalErr: boolean;
  approvaling: boolean;
};
export const CentifyResult = ({ approvalErr, approvaling }: Props) => {
  const [userInfo] = useUserInfoStore()((state) => [state.userInfo]);
  return (
    <section className={styles.approval}>
      <div className={styles.approval_content}>
        <div
          className={!approvalErr ? styles.approvaling : styles.approval_err}
        />
        <div
          className={
            !approvalErr ? styles.approvaling_text : styles.approval_err_text
          }
        >
          {approvalErr ? `审核失败： ${userInfo.realNameRemark}` : "审核中，请耐心等待..."}
        </div>
      </div>
    </section>
  );
};
